// Copyright (c) 2018 Deere & Company

const getClaimStatuses = (claimStatuses, showDealerInvoice) =>
    showDealerInvoice ?
        claimStatuses.map(status => status.key) :
        claimStatuses.filter(status => status.key !== '9').map(status => status.key);

/* eslint-disable complexity, max-params */

export const createAllClaimsPayload = (facets, exportToExcel = '', language = '', showDealerInvoice = false, layoutName = '', listId = '') => ({
    accounts: facets.dealerAccountsFacet.selectedDealers.map(dealer => dealer.account),
    claimStatuses: getClaimStatuses(facets.claimStatusFacet.selectedClaimStatus, showDealerInvoice),
    dateType: facets.dateTypeFacet.key,
    export: exportToExcel,
    fromDate: facets.claimDateRangeFacet.dateRange.from,
    language,
    layout: layoutName,
    listId,
    toDate: facets.claimDateRangeFacet.dateRange.to
});

/* eslint-enable complexity, max-params */



// WEBPACK FOOTER //
// ./src/claim/all-claims/services/all-claims-payload.js